import script from "./octopus.vue?vue&type=script&setup=true&lang=ts"
export * from "./octopus.vue?vue&type=script&setup=true&lang=ts"

import "./octopus.vue?vue&type=style&index=0&id=34e3807a&scoped=true&lang=less"
import "./octopus.vue?vue&type=style&index=1&id=34e3807a&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34e3807a"]])

export default __exports__